// src/store/thunks/administrators/forceLogoutAdminThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';

export const forceLogoutAdminThunk = createAdminAsyncThunk<
  void,
  { id: string }
>('administrators/forceLogout', async ({ id }, { extra: { administratorsService } }) => {
  await administratorsService.forceLogout(id);
});
